import {useEffect} from 'react'
export const useEvergageBeacon = () => {
    useEffect(() => {
        if (typeof window === 'undefined') return
        const isLocalhost = /^localhost$/i.test(window.location.hostname)

        if (
            isLocalhost ||
            document.querySelector(
                'script[src="//cdn.evgnet.com/beacon/delonghi/delonghi_prod/scripts/evergage.min.js"]',
            )
        ) {
            return
        }

        const script = document.createElement('script')
        script.type = 'text/javascript'
        script.src = '//cdn.evgnet.com/beacon/delonghi/delonghi_prod/scripts/evergage.min.js'
        script.async = true
        document.body.appendChild(script)
        window.evergageBeaconLoaded = true
    }, [])
}
